import React, { useMemo } from 'react';

import { SvgIcon } from 'js/app/components/common/SvgIcon';
import { useOnClose } from 'js/components/common/PopupManager';

import { GAMES_INFO_POPUP_ID } from 'js/app/components/popups/GamesInfoPopup/constants';
import { getGameListFromStorage } from 'js/app/components/popups/GamesInfoPopup/utils';
import { useNavigate } from 'js/hooks/navigate';

import style from './NavigationArrows.scss';

export const NavigationArrows = ({ gameCode }) => {
    const onClose = useOnClose(GAMES_INFO_POPUP_ID);
    const navigateWithReplace = useNavigate({ replace: true });

    const { leftGameUrl, rightGameUrl } = useMemo(() => {
        const gameCodesList = getGameListFromStorage();
        const currentIndex = gameCodesList.findIndex(listGameCode => listGameCode === gameCode);
        const leftGame = gameCodesList[currentIndex - 1];
        const rightGame = gameCodesList[currentIndex + 1];

        return {
            leftGameUrl: leftGame ? `/online-game/${leftGame}` : null,
            rightGameUrl: rightGame ? `/online-game/${rightGame}` : null
        };
    }, [gameCode]);

    const handleArrowClick = (url) => {
        onClose();
        navigateWithReplace(url);
    };

    return (
        <>
            {leftGameUrl && (
                <div
                    className={style.leftArrow}
                    onClick={() => handleArrowClick(leftGameUrl)}
                >
                    <SvgIcon
                        type="arrow-left"
                        className={style.leftArrowIcon}
                    />
                </div>
            )}

            {rightGameUrl && (
                <div
                    className={style.rightArrow}
                    onClick={() => handleArrowClick(rightGameUrl)}
                >
                    <SvgIcon
                        type="arrow-right"
                        className={style.rightArrowIcon}
                    />
                </div>
            )}
        </>
    );
};
